import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";

const RowConfirmModal = ({ show, onHide, role, onConfirm }) => {
  const [checked, setChecked] = useState(false);
  const [remarks, setRemarks] = useState("");

  const isFinance = role === "financeExecutive";
  const label = isFinance
    ? "I approve this payment"
    : "I confirm this payment is received";

  const handleSubmit = () => {
    if (!checked) return alert("Please check the confirmation");
    if (!remarks.trim()) return alert("Remarks are required");
    onConfirm({ remarks });
    setChecked(false);
    setRemarks("");
  };

  const handleHide = () => {
    setChecked(false);
    setRemarks("");
    onHide();
  };

  return (
    <Modal show={show} onHide={handleHide} centered size="sm">
      <Modal.Header closeButton >
        <Modal.Title>
          {isFinance ? "Finance Approval" : "Service Executive Confirmation"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-4">
        <label
          className="d-flex align-items-center gap-2 mb-3"
          style={{ cursor: "pointer" }}
        >
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            style={{ width: "16px", height: "16px" }}
          />
          <span >{label}</span>
        </label>

        <div className="commTopButtonRightLeftPadding">
          <TextAreaField
            className="inputBox"
            value={remarks ?? ""}
            disabled={!checked}
            placeholder="Remarks"
            onChange={(e) => setRemarks(e.target.value)}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className="p-4">
        <button className="btnTable btn-danger" onClick={handleHide}>
          Cancel
        </button>
        <button className="btnTable" onClick={handleSubmit}>
          {isFinance ? "Approve" : "Confirm"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default RowConfirmModal;
